import React, { useEffect } from 'react';
import { postApi } from '../../apiUtils';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { AttachmentCategoriesForm } from '../../forms/attachmentCategories/AttachmentCategoriesForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { AttachmentCategoryInputs } from '../../types/attachmentCategory.types';
import { API_URL } from '../../utils/apiUrl';

export function AttachmentCategoriesNew() {
  const { translate } = useTranslation();
  const transFormName = 'AttachmentCategory.Create';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();

  useEffect(() => {
    setValue({
      pageName: 'New attachment category',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Attachment categories', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: AttachmentCategoryInputs = {
    id: 0,
    entity: '',
    name: '',
    requiredRole: null,
    sortOrder: 0,
    visible: true,
  };

  const onSubmit = async (e) => {
    if (e !== null) e.preventDefault();
    let isOk = false;
    startLoading();
    await postApi<AttachmentCategoryInputs>({
      url: API_URL.ATTACHMENT_CATEGORY_POST,
      data: formData,
      callAfterSuccess: () => {
        isOk = true;
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper heading={translate!('New attachment category', transFormName)}>
      <AttachmentCategoriesForm onSubmit={onSubmit} formData={formData} />
    </PageContentWrapper>
  );
}

export default AttachmentCategoriesNew;
